<div class="modal-header">
    <h3 class="modal-title mb-0 fw-bolder">{{type == 'active' ? 'Active' : 'Total'}} Loan List</h3>
</div>
<div class="modal-body p-0">
    <table class="table table-bordered table-striped table-sm mb-0">
        <thead class="table-primary">
            <tr>
                <th>No</th>
                <th>Name</th>
                <th>Mobile</th>
                <th>Loan Amount</th>
                <th>Loan Date</th>
                <th>Payment Amount</th>
                <th>Overridng Commission</th>
                <th *ngIf="type != 'active'">Status</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let loan of loans; let i = index">
                <td>{{i + 1}}</td>
                <td>{{loan.name}}</td>
                <td>{{loan.mobile}}</td>
                <td>{{loan.loan_amount}}</td>
                <td>{{loan.timestamp | date:'dd-MM-yyyy'}}</td>
                <td>{{loan.payment_received | number:'1.2-2'}}</td>
                <td>{{loan.override_commission}}%</td>
                <td *ngIf="type != 'active'">{{loan.status == 2 ? 'Active' : 'Completed'}}</td>
            </tr>
            <tr *ngIf="loans.length == 0"><td colspan="8" class="text-center">No data found</td></tr>
        </tbody>
    </table>
</div>